import { nanoid } from 'nanoid'
import { setContext } from '@apollo/client/link/context'

export const requestIdLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      requestId: nanoid(10)
    }
  }
})
